import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { BoardData } from "@/model/board";
import { asSemiReadonly } from "@/utils/vue";

import { useBoardsStore } from "./boards";
import { useNavigationStore } from "./navigation";

export const useFlexStore = defineStore("flex", () => {
  const currentFlexBoard = ref<BoardData<"flex"> | null>(null);

  const flexBoards = computed(() =>
    Object.values(useBoardsStore().boards).filter((board) => board.type === "flex"),
  );

  return {
    currentFlexBoard: asSemiReadonly(currentFlexBoard),

    flexBoards,
    flexBoardByName: (name: string) => flexBoards.value.find((board) => board.name === name),
    flexBoardById: (id: string) => flexBoards.value.find((board) => board.id === id),
    flexBoardsByType: (type: string) =>
      flexBoards.value.filter((board) => board.flexType.id === type),

    setCurrentFlexBoard: (flex: BoardData<"flex">) => {
      useNavigationStore().setFlexInType(flex);
      currentFlexBoard.value = flex;
    },
    unsetCurrentFlexBoard: () => (currentFlexBoard.value = null),
    setFlexBoards: (flexBoards: Array<BoardData<"flex">>) => {
      useBoardsStore().updateBoards("flex", flexBoards, (exist, board) => {
        exist.name = board.name;
        exist.flexType = board.flexType;
      });
    },
  };
});
